import { MaterialEditRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const editRoute = {
  path: 'edit',
  element: <MaterialEditRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Edit</span>,
  }),
};